export default __webpack_public_path__ + "static/media/earn_horse.9cf5cfb2.png";